import { createFileRoute, notFound } from "@tanstack/react-router";
import { LabsLabPlaceholder } from "~/components/labs/LabsExperience";
import { seo, seoLinks } from "~/utils/seo";

const LAB_SLUGS: Record<string, true> = {
  "least-privilege-policy-in-cel": true,
  "detect-over-permissioned-service-account": true,
  "escalate-through-a-misconfigured-connector": true,
  "read-a-connector-sync-like-a-timeline": true,
  "design-a-jit-access-request-flow": true,
  "replay-an-oauth-token-past-its-scope": true,
  "certify-an-access-review-in-10-minutes": true,
  "baseline-anomaly-detection-on-grants": true,
  "find-the-shadow-admin": true,
};

export const Route = createFileRoute("/labs/labs/$slug")({
  loader: ({ params }) => {
    if (!LAB_SLUGS[params.slug]) throw notFound();
    return { slug: params.slug };
  },
  head: () => ({
    meta: seo({
      title: "Lab | C1 Labs",
      description: "A hands-on identity-security exercise from C1 Labs. Coming soon.",
      url: "/labs/labs",
    }),
    links: seoLinks({ url: "/labs/labs" }),
  }),
  component: LabDetail,
});

function LabDetail() {
  return <LabsLabPlaceholder slug={Route.useLoaderData().slug} />;
}
